import { createApi } from "@reduxjs/toolkit/query/react";

import { setUser } from "./loginSlice";
import { sectionsToRole } from "../../app/roles";
import baseQueryWithReauth from "../../common/utils/baseQueryReauth";

import config from "../../config";
const { envs } = config;
const { login: apiPath } = config.endpoints;

const loginService = createApi({
 reducerPath: "loginService",
 baseQuery: baseQueryWithReauth,
 endpoints: (builder) => ({
  userLogin: builder.mutation({
   queryFn: async ({ username, password }) => {
    const params = {
     ...envs.keycloak,
     username,
     password,
    };
    const body = Object.keys(params)
     .map((key) => {
      return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
     })
     .join("&");
    const response = await fetch(
     envs.apiUrl + envs.apiPrefix + apiPath.userLogin,
     {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body,
      mode: "cors",
     }
    );
    try {
     const data = await response.json();
     if (data?.error || data?.error_description) {
      throw new Error(data?.error + data?.error_description || "");
     }
     return { data };
    } catch (error) {
     return { error };
    }
   },
   transformResponse: (response, meta, arg) => response.data,
  }),
  getSections: builder.query({
   // note: an optional `queryFn` may be used in place of `query`
   query: ({ access_token }) => ({
    url: apiPath.getSections,
    headers: {
     "Authorization": `Bearer ${access_token}`,
    },
   }),
   // Pick out data and prevent nested properties in a hook or selector
   transformResponse: (response, meta, arg) => response,
   // Pick out errors and prevent nested properties in a hook or selector
   transformErrorResponse: (response, meta, arg) => response.status,
   async onQueryStarted(args, { dispatch, queryFulfilled }) {
    try {
     const { data } = await queryFulfilled;
     // `onSuccess` side-effect
     dispatch(setUser({ role: sectionsToRole[data.sections], ...args }));
    } catch (err) {
     // `onError` side-effect
     console.log(err);
    }
   },
  }),
 }),
});

export default loginService;

export const { useUserLoginMutation, useGetSectionsQuery } = loginService;
